export const categories = [
  { id: 'movies', label: 'Фильмы', image: '/films.webp' },
  { id: 'series', label: 'Сериалы', image: '/series.webp' },
  { id: 'games', label: 'Видеоигры', image: '/games.webp' },
  { id: 'anime', label: 'Аниме', image: '/anime.webp' },
] as const;

export type CategoryId = (typeof categories)[number]['id'];

export const isCategoryEnabled = (category: string, selected: readonly string[]) => {
  const id = ({ film: 'movies', game: 'games' } as Record<string, string>)[category] ?? category;
  return selected.includes(id);
};

export const isCampaignCategory = (value: string): value is CategoryId => categories.some(({ id }) => id === value);
